import { Pipe, PipeTransform } from '@angular/core';
import _isEmpty from 'lodash/isEmpty';

@Pipe({
  name: 'objectIsEmpty',
  pure: true,
  standalone: false,
})
export class ObjectIsEmptyPipe implements PipeTransform {
  transform(value: Record<string, unknown>): boolean {
    return _isEmpty(value);
  }
}
